import React from 'react'
import "./color.css"

function RedLL() {
    var x = localStorage.getItem("percentage llp")
    return (
        <div className = "red__backgroundll">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default RedLL
